/// <summary>
/// This object provides js functions for ... <br/>
/// <br/>
/// Author: ARF<br />
/// Date: 20.9.2022<br />
/// Copyright ©: EUDT GmbH 2022 <br />
/// Version-History:<br />
/// **********************************************************************<br />
/// *** v1.0.0 - 20.9.2022                                               *<br />
/// **********************************************************************<br />
/// * - basic functionality                                              *<br />
/// **********************************************************************<br />
/// </summary>
jQuery.widget("bluaul.FullDashboard", $.bluaul.vcMenuTemplate, {
   
   
    _create: function () {
        var me = this;
        try {
            me.element.html("");
            me.options.invoke.vcvid = 342;
            me.options.invoke.vcgid = Math.floor(Math.random() * Math.floor(1000000));
            me._super();
          
        } catch (e) { me.writeError('_create', e); return false;}
        return true;
    },





    _initVariables: function () {
        var me = this;
        try {
            me._super();
            me.settings.defaultChart = "dashboard";
            me.settings.menu.top.showMenuAsDropdown = false;
            me.settings.menu.top.interval.intervals = [1, 3, 5];
            me.settings.menu.top.interval.default = 1; //we start with days
            me.settings.toggleView = true;
            me.settings.showSignalsInContent = false;
            me.settings.signalSelection = false;
            me.settings.showAllSignalsAtStart = false;
            me.settings.enableFilterForInvalidSignals = false;
            me.settings.hideSignalsWithNotAllowedSettings = true;
            me.settings.showArchiveRules = false;
            me.settings.enableMeta = false;

            me.settings.menu.top.showHeaders = true;
            me.settings.menu.top.interval.enabled = true;
            me.settings.menu.top.datatype.enabled = false;
            me.settings.menu.top.charts.enabled = false;
            me.settings.menu.top.opt.enabled = false;
            me.settings.menu.top.opt.showInterventions = false;
            me.settings.menu.top.opt.showTickets = false;

            me.settings.menu.main.button.enabled = true;
            me.settings.menu.main.button.cols = 1;
            me.settings.menu.main.button.selection.enabled = false;
            me.settings.menu.main.button.reload.broadcastStatus = true;
            me.settings.menu.main.date.enabled = true;
            me.settings.menu.main.dateComparison.enabled = true;
            me.settings.menu.main.rampResolution.enabled = false;
            me.settings.menu.main.rampOptions.enabled = false;
            me.settings.menu.main.rampTempCharts.enabled = false;
            me.settings.menu.main.specificOptions.enabled = false;
            me.settings.menu.main.history.enabled = false;

            me.settings.menu.top.opt.showTags = false;
            me.settings.menu.top.opt.showRules = false;
            me.settings.menu.top.export.enabled = false;
            me.settings.menu.top.export.showFavorites = false;
            me.settings.menu.top.export.showShare = false;
            me.settings.selection.choice.enabled = false;
            me.settings.selection.entries.button.enabled = false;
            me.settings.selection.entries.signals.showIcons = false;

            me.settings.subvisual.content.signalSelection = false;


        } catch (e) {
            me.writeError('_initVariables', e);
            return false;
        }
        return true;
    },


    _loadSubvisualContent: function (contentStatus) {
        var me = this;

        try {
            me._initSubvisualContent(contentStatus); 
            if (!me.error) {
                var param = me.options.invoke.parameter;
                me.vcMenu.subvisual.content.data("dashboardData", {
                    status: contentStatus,
                    signals: me.signals
                });
                me.vcMenu.subvisual.content.Dashboard({invokeType: "addVisualBase", parameter: param});

            }

        } catch (e) { me._writeErr(e); }


    },


});

